/** @format */
import { css } from 'styled-components';

import { smallTablet } from '@toucan/client/global/application';

import { StyledListingPageProps } from './index';

/**
 * Base styles for the listing page component
 */
const baseStyles = () => css`
    .control-group {
        display: none;
    }

    .small-tablet-filters {
        display: none;
    }

    .desktop-filters {
        display: grid;
    }

    ${smallTablet(css`
        .control-group {
            display: block;
        }

        .divider {
            display: none;
        }

        .small-tablet-filters {
            display: flex;
        }

        .desktop-filters {
            display: none;
        }
    `)}

    .spelling-suggestion-notice {
        margin-bottom: var(--layout-spacing-24);
    }

    .link-wrapper {
        position: relative;
    }

    .card-link {
        width: 100%;
        height: 100%;
        padding: 0.4rem;
        border-radius: 1.2rem;

        > span {
            height: 100%;
        }
    }

    .control-group {
        position: relative;
    }

    .control-group-skeleton {
        height: 100%;
        width: 100%;
        position: absolute;
        gap: 0.4rem;
        display: none;
    }
`;

const loadingStyles = () => css`
    .control-group-skeleton {
        display: flex;
    }

    .control-group-content {
        visibility: hidden;
    }
`;

/**
 * The listing page component styles
 *
 * @param {StyledListingPageProps} props The listing page properties object
 */
export const styles = ({ isLoading }: StyledListingPageProps) => {
    return css`
        ${baseStyles()}
        ${isLoading && loadingStyles()}
    `;
};
